(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flexible-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.FlexiAnimations) return;

    var OFFSCREEN = 'scroll-trigger--offscreen';
    var DESIGN = 'scroll-trigger--design-mode';

    function onIntersection(entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove(OFFSCREEN);
        observer.unobserve(entry.target);
      });
    }

    function blocks(root) {
      return Array.prototype.filter.call(root.querySelectorAll('.flexi-library[id]'), function (el) {
        return !el.closest('.flexi-equal-card, .blaze-slider');
      });
    }

    function isTopLevel(wrapper, block) {
      var parent = block.parentElement;
      if (!parent) return false;
      return parent === wrapper || (parent.classList.contains('shopify-block') && parent.parentElement === wrapper);
    }

    function prepare(scope) {
      scope.querySelectorAll('.flexi-section-wrapper.scroll-trigger').forEach(function (wrapper) {
        var all = blocks(wrapper);
        all.forEach(function (block) {
          if (!isTopLevel(wrapper, block)) return;

          var leaves = all.filter(function (el) {
            return el !== block && block.contains(el) && !all.some(function (other) {
              return other !== el && el.contains(other);
            });
          });

          if (!leaves.length) {
            block.classList.add('scroll-trigger', 'animate--fade-in', OFFSCREEN);
            return;
          }

          leaves.forEach(function (leaf, index) {
            leaf.classList.add('scroll-trigger', 'animate--slide-in', OFFSCREEN);
            leaf.style.setProperty('--animation-order', index);
          });
        });
      });
    }

    function init(root, designMode) {
      var scope = root && root.querySelector ? root : document;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      prepare(scope);

      var elements = Array.prototype.filter.call(scope.getElementsByClassName('scroll-trigger'), function (element) {
        return element.classList.contains('animate--fade-in') || element.classList.contains('animate--slide-in');
      });
      if (!elements.length) return;

      if (designMode) {
        elements.forEach(function (element) {
          element.classList.add(DESIGN);
          element.classList.remove(OFFSCREEN);
        });
        return;
      }

      var observer = new IntersectionObserver(onIntersection, {
        rootMargin: '0px 0px -50px 0px'
      });

      elements.forEach(function (element) {
        if (element.dataset.flexiScrollBound) return;
        element.dataset.flexiScrollBound = 'true';
        observer.observe(element);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document, false); });
    } else {
      init(document, false);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target, window.Shopify && Shopify.designMode);
    });

    window.FlexiAnimations = { init: init };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
